import { toast, Bounce } from 'react-toastify';

const DEFAULT_TOAST_OPTIONS = Object.freeze({
  position: 'bottom-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'colored',
  transition: Bounce,
});

export function notifySuccess(message, opts = {}) {
  if (!message) return;

  toast.success(message, {
    ...DEFAULT_TOAST_OPTIONS,
    ...(opts || {}),
  });
}
